import React from "react";
import { GridRow, GridColumn, Stack, Icon, Label } from "sprint-common-web";

import { FileRecordDetails } from "../FileRecordDetails";

interface FileRecordBuzzViewProps {
    fileRecordDetails: FileRecordDetails;
}

export const FileRecordBuzzView = ({ fileRecordDetails }: FileRecordBuzzViewProps): JSX.Element => {
    return (
        <GridRow>
            <GridColumn sm={6}>
                <Stack styles={{ root: { marginBottom: 10 } }}>
                    <Label>Notifications approved</Label>
                    {fileRecordDetails.isNotificationApproved ? <Icon iconName="Accept" /> : <Icon iconName="Cancel" />}
                </Stack>
            </GridColumn>
        </GridRow>
    );
};
